// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"10bf97a7","453":"3dfc804b","732":"dd67cf8b","977":"99fff5c9"}[chunkId] + ".chunk.js";
};